import ko from "knockout";
import pino from "pino";

// SPA logging
// Use simple console transport to avoid environment-specific pino-pretty requirement
const logger = pino({ level: "debug" });

export class SupervisorCheckViewModel {
  constructor() {
    this.isSupervisor = ko.observable(false);
  }

  async checkSupervisorProfile(api, agentId) {
    try {
      const agentInfo = await api.getAgentInfoSync(agentId);
      this.processAgentInfo(agentInfo);
    } catch (error) {
      this.handleError(error);
    }

    logger.debug("SupervisorCheck.isSupervisor", { isSupervisor: this.isSupervisor() });
    sessionStorage.setItem("isSupervisor", this.isSupervisor().toString());
  }

  processAgentInfo(data) {
    logger.info("SupervisorCheck.agentInfo", data);
    sessionStorage.setItem("teamName", data.agents[0].teamName);
    const allowedProfiles = sessionStorage.getItem("supervisorProfiles");
    const supervisorProfiles = allowedProfiles ? allowedProfiles.toUpperCase().split(",") : [];
    const agentProfile = data.agents[0].profileName.toUpperCase();

    this.isSupervisor(supervisorProfiles.some((profile) => profile.trim() === agentProfile));
  }

  handleError(error) {
    logger.error("SupervisorCheck.checkSupervisorProfile failed", error);
  }
}
